module.exports = __webpack_public_path__ + "static/media/circleInsideSquare.625d5d8e.svg";